"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivineResolutionAbilityHandler = exports.DivineResolutionActorAbilityFactory = exports.DivineResolutionAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_2 = require("../../core/actions/core");
const core_3 = require("../../core/event-handlers/core");
const EventFilter_1 = require("../../core/events/EventFilter");
class DivineResolutionAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DivineResolution;
        this.__typeName = "DivineResolution";
    }
}
exports.DivineResolutionAbilityArgs = DivineResolutionAbilityArgs;
let DivineResolutionActorAbilityFactory = class DivineResolutionActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DivineResolution", "Self", 0);
    }
};
DivineResolutionActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DivineResolution")
], DivineResolutionActorAbilityFactory);
exports.DivineResolutionActorAbilityFactory = DivineResolutionActorAbilityFactory;
let DivineResolutionAbilityHandler = class DivineResolutionAbilityHandler {
    init(sequence, container, actorId) {
        const additionalEffects = Array.of();
        if (container.hasAttribute(actorId, "Charm_HighPriestess_0")) {
            additionalEffects.push(new core_1.LinkedEventHandlerEffectArgs("Divine Penance", "Casting a healing spell will blast a random enemy", false, container.registerEventHandler(actorId, EventType_1.EventType.AbilityUsed, Schedule_1.Schedule.Unlimited, new core_3.DispatchActionEventHandlerArgs(new core_2.UseAbilityOnRandomEnemyActionArgs("Blast", false), Target_1.Target.Self), EventFilter_1.EventFilter.mk("AbilityUsed", {
                "args.__typeName": {
                    oneOf: [
                        "Heal",
                        "Regeneration",
                        "AeridynesSpring",
                        "SorisHug",
                        "WhispersOfTheAncientOne",
                        "NorisSacrifice",
                        "Sanctuary"
                    ]
                }
            }))));
        }
        container.applyBuff({
            sequence,
            targetId: actorId,
            creatorId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingIncrease, 25),
                new core_1.PassiveBuffEffectArgs("Divine Resolution", "Grants all allies regen for 10% of WILL", new core_1.RegenerationEffectArgs("DivineResolution", container.getPercentOfBaseHealth(actorId, 5)))
            ], false),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
DivineResolutionAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DivineResolution)
], DivineResolutionAbilityHandler);
exports.DivineResolutionAbilityHandler = DivineResolutionAbilityHandler;
